import { render, staticRenderFns } from "./viewDate.vue?vue&type=template&id=37af8982&scoped=true&"
import script from "./viewDate.vue?vue&type=script&lang=js&"
export * from "./viewDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af8982",
  null
  
)

export default component.exports